module.exports = __webpack_public_path__ + "static/img/ALE-3.3b900693.png";